var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackspaceArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.685,
    height: 8.764,
    viewBox: "0 0 11.685 8.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.711,76.5h-7.3a.877.877,0,0,0-.779.438L0,80.882l2.629,3.944a.992.992,0,0,0,.779.438h7.3a.977.977,0,0,0,.974-.974V77.474A.977.977,0,0,0,10.711,76.5ZM9.251,82.635l-.682.682L6.816,81.564,5.064,83.316l-.682-.682,1.753-1.753L4.382,79.129l.682-.682L6.816,80.2l1.753-1.753.682.682L7.5,80.882Z",
    transform: "translate(0 -76.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspaceArrow);
export default __webpack_public_path__ + "static/media/backspace-arrow.e74707221ba4bd249f33843051ef6632.svg";
export { ForwardRef as ReactComponent };